import { extendTheme } from "@chakra-ui/react";

import { Button } from "./components/button";

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        // bg: "#f1f3f5",
        bg: "#fff",
      },
    },
  },
  colors: {
    primary: {
      50: "#e0edf6",
      100: "#b3d3e8",
      200: "#80b5d9",
      300: "#4d97ca",
      400: "#2681be",
      500: "#006bb3",
      600: "#0063ac",
      700: "#0058a3",
      800: "#004e9a",
      900: "#003c8b",
    },
    // brand: "#ff6600",
    darkAccent: "#d4390d",
    dark: "#004976",
    lightAccent: "#9ea2af",
    light: "#fbfafb",
    lightBg: "#f1f3f5",
    brand: {
      darkblue: "#004976",
      altblue: "#42799D",
      blue: "#5184A6",
      lightblue: "#BCD9E2",
      orange: "#E76E1F",
      green: "#6EAA39",
    },
  },
  components: {
    Button,
  },
});
